// Ported from dev-scrips-pm-react src/scheduling/components/appointments/add-note-dialog.tsx (PROD-1193)
import { useEffect, useState } from 'react';
import { Button, Modal, TextArea } from '@scripsteam/scrips-signal-ds';
import { useAddAppointmentNote } from '@/scheduling/services/use-add-appointment-note';

/**
 * Internal-note dialog. Mirrors Flutter `showAddNoteAlert`
 * (calendar_tab.dart:1471): textarea seeded with the current note,
 * Save fires PUT /api/Appointment/{id}/Note. 300-char limit per Flutter.
 */

interface NoteTarget {
  appointmentId: string;
  /** Existing comment, if any — pre-fills the textarea. */
  initialNote?: string;
}

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  target: NoteTarget | null;
}

const MAX_LEN = 300;

export function AddNoteDialog({ open, onOpenChange, target }: Props) {
  const [note, setNote] = useState('');
  const mutation = useAddAppointmentNote();

  useEffect(() => {
    if (open) setNote(target?.initialNote ?? '');
  }, [open, target?.initialNote]);

  if (!target) return null;

  const submit = async () => {
    await mutation.mutateAsync({ id: target.appointmentId, note });
    onOpenChange(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => onOpenChange(false)}
      title="Add internal note"
      size="sm"
      footer={<><Button
            variant="secondary"
            onClick={() => onOpenChange(false)}
            disabled={mutation.isPending}
          >
            Cancel
          </Button>
          <Button onClick={submit} disabled={mutation.isPending}>
            {mutation.isPending ? 'Saving…' : 'Save note'}
          </Button></>}
    >
        {/* The design's body (SchedAddNoteBody): the DS TextArea, 4 rows, the aria-label kept (PROD-1817) and the DS counter. */}
        <TextArea
          value={note}
          onChange={(e) => setNote(e.target.value.slice(0, MAX_LEN))}
          autoFocus
          rows={4}
          maxLength={MAX_LEN}
          placeholder="Add internal note"
          aria-label="Internal note"
        />
      </Modal>
  );
}
